import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import CompetenciesServices from "./Competencies.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getCompetency = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_COMPETENCY,
      payload: true,
    });
    const resp = await CompetenciesServices.getCompetency(filters);
    dispatch({
      type: actions.GET_COMPETENCY,
      payload: {
        competencies: resp.data.data,
        competenciesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.COMPETENCY_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.COMPETENCY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COMPETENCY,
      payload: false,
    });
  }
};


export const saveCompetency =
  (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_COMPETENCY,
        payload: true,
      });
      const resp = await CompetenciesServices.saveCompetency(data);
      const { competencies, competenciesLength } = getState().planCarreraCompetency;
      const _competencies = [...competencies, resp.data];
      dispatch({
        type: actions.GET_COMPETENCY,
        payload: {
          competencies: _competencies,
          competenciesLength: competenciesLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_COMPETENCY,
        payload: false,
      });
    }
  };

export const editCompetency =
  (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_COMPETENCY,
        payload: true,
      });
      const resp = await CompetenciesServices.editCompetency(id, data);
      const { competencies, competenciesLength } = getState().planCarreraCompetency;
      let _competencies = [...competencies]
      _competencies[index] = resp.data;
      dispatch({
        type: actions.GET_COMPETENCY,
        payload: {
          competencies: _competencies,
          competenciesLength: competenciesLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_COMPETENCY,
        payload: false,
      });
    }
  };

export const deleteCompetency = (id, index) => async (dispatch, getState) => {
  try {
   
    dispatch({
      type: actions.LOADING_COMPETENCY,
      payload: true,
    });
    await CompetenciesServices.deleteCompetency(id);
    const { competencies, competenciesLength } = getState().planCarreraCompetency;
    let _competencies = [...competencies]
    _competencies.splice(index, 1);
    dispatch({
      type: actions.GET_COMPETENCY,
      payload: {
        competencies: _competencies,
        competenciesLength: competenciesLength - 1,
      },
    });
    dispatch({
      type: actions.COMPETENCY_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;                         
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }

    dispatch({
      type: actions.COMPETENCY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COMPETENCY,
      payload: false,
    });
  }
};
